import { MEDIA } from '../constants/media';

// Import components
import SeoHead from '../components/seo/SeoHead';
import JsonLd from '../components/seo/JsonLd';
import { getAppPageJsonLd } from '../components/seo/structuredData';
import StickyNavbar from '../components/navbar/StickyNavbar';
import DisplayAd from '../components/ads/DisplayAd';
import Footer from '../components/landing/Footer';
import AppStoreButton from '../components/button/AppStoreButton';
import PlayStoreButton from '../components/button/PlayStoreButton';
import Badge from '../components/badge/Badge';
import AppDownloadQR from '../components/app/AppDownloadQR';

export default function AppPage() {
  return (
    <div className="w-full min-h-screen bg-white text-gray-800 flex flex-col">
      <SeoHead route="/app" />
      <JsonLd data={getAppPageJsonLd()} />
      <StickyNavbar />

      <main className="flex flex-col py-20 md:py-24 px-8 max-w-6xl mx-auto w-full">
        <div className="flex flex-col lg:flex-row items-center justify-between">
          {/* Left side - Text and buttons */}
          <div className="flex-1 max-w-2xl">
            <div className="flex flex-col gap-6">
              {/* Badges */}
              <div className="flex flex-wrap items-center gap-2">
                <Badge variant="primary" showDot>
                  Group Scheduling
                </Badge>
              </div>

              {/* Headline */}
              <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 leading-tight text-left">
                Schedule on your phone with{' '}
                <span className="text-5xl text-blue-600">WhenWeMeet?</span>
              </h1>

              {/* Description */}
              <p className="text-lg text-gray-600 leading-relaxed text-left">
                Take group scheduling anywhere. Create meeting planners, share
                availability, and find the perfect time — all from your phone.
                Free, fast, and works seamlessly across iOS and Android.
              </p>

              {/* Download Buttons */}
              <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
                <AppStoreButton className="w-auto min-w-[200px]" />
                <PlayStoreButton className="w-auto min-w-[200px]" />
              </div>

              <div className="flex flex-col items-center gap-2 w-full">
                <div className="flex justify-center bg-gray-50 rounded-lg p-4 border border-gray-200">
                  <AppDownloadQR size={140} />
                </div>
                <p className="text-sm text-gray-500 text-center leading-relaxed max-w-xs">
                  Scan this QR code with your phone to download the WhenWeMeet
                  app
                </p>
              </div>
            </div>
          </div>

          {/* Right side - Screenshot placeholder */}
          <div className="flex-1">
            {/* Phone Screen */}
            <div>
              <img
                src={MEDIA.appPreview}
                alt="WhenWeMeet app preview"
                className="w-full object-contain"
              />
            </div>
          </div>
        </div>

        <div className="mx-auto mt-12">
          <DisplayAd />
        </div>
      </main>

      <Footer />
    </div>
  );
}
